var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value && _vm.value.length)?_c('div',{staticClass:"timeline"},[_c('ul',{staticClass:"timeline__content"},_vm._l((_vm.value),function(item,index){return _c('li',{key:index,staticClass:"timeline__item",class:{
        'timeline__item--active': _vm.checkActive(index),
        'timeline__item--check': item['completed'],
      }},[_c('span',{staticClass:"timeline__item-content"},[_vm._v(_vm._s(item.content))]),_c('strong',{staticClass:"timeline__item-status"},[_vm._v(" "+_vm._s(item.status)+" ")])])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }